import hooks from './hooks';
import animations from './animations';

const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(...args));

const debounce = (callback, wait) => {
  let timeout = null;
  return (...args) => {
    const next = () => callback(...args);
    clearTimeout(timeout);
    timeout = setTimeout(next, wait);
  };
};
function clamp(num, min, max) {
  return num <= min ? min : num >= max ? max : num;
}
const isEmptyObject = obj => Object.keys(obj).length === 0;

const pluralize = (count, noun, suffix = 's', minimal = false) =>
  `${!minimal ? count : ' '} ${noun}${count !== 1 ? suffix : ''}`;

const roundTo = (n, precision) =>
  Math.round(n * 10 ** precision) / 10 ** precision;

const sleep = (ms = 1000) => new Promise(res => setTimeout(res, ms));

const unwrapIterable = arg => (Array.isArray(arg) ? arg[0] : arg);

function zeroPad(number, width) {
  var string = String(number);
  while (string.length < width) string = '0' + string;
  return string;
}

const makeId = _ =>
  Math.random()
    .toString(36)
    .substring(2, 15);

const noop = () => {};

const RGBLinearShade = (p, c) => {
  var i = parseInt,
    r = Math.round,
    [a, b, c, d] = c.split(','),
    P = p < 0,
    t = P ? 0 : 255 * p,
    P = P ? 1 + p : 1 - p;
  return (
    'rgb' +
    (d ? 'a(' : '(') +
    r(i(a[3] == 'a' ? a.slice(5) : a.slice(4)) * P + t) +
    ',' +
    r(i(b) * P + t) +
    ',' +
    r(i(c) * P + t) +
    (d ? ',' + d : ')')
  );
};
function getCurrentDate() {
  let d = new Date();
  let m = d.getMonth() + 1;
  let y = d.getFullYear();
  return [m, y];
}
export default {
  ...animations,
  ...hooks,
  noop,
  callAll,
  clamp,
  debounce,
  getCurrentDate,
  isEmptyObject,
  pluralize,
  roundTo,
  sleep,
  RGBLinearShade,
  unwrapIterable,
  zeroPad,
  makeId,
};
